//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Product",
  data() {
    return {
      datames: {},
      tab: "",
      chodata: {},
    };
  },
  methods: {
    getProduct() {
      this.axios
        .get("https://m.mingyuanyun.com/wxapp-api/ad/get-products", {
          params: {},
        })
        .then((res) => {
          if (res.data.data) {
            this.datames = res.data.data;
            this.formatData();
          }
        });
    },
    formatData() {
      switch (this.tab) {
        case "suport":
          this.chodata = this.getProductDetail("明源产品支持服务");
          break;
        case "yunERP":
          this.chodata = this.getProductDetail("智慧ERP");
          break;
      }
    },
    getProductDetail(name) {
      if (this.datames) {
        for (var i = 0; i < this.datames.length; i++) {
          if (this.datames[i].shortcutName === name) return this.datames[i];
        }
      }
      return this.datames[0];
    },
  },
  mounted() {
    this.tab = this.$route.query.tab;
    this.getProduct();
  },
};



// WEBPACK FOOTER //
// ./src/components/Product.vue